// extracted by mini-css-extract-plugin
module.exports = {"main-component":"walkthroughArrow_main-component__1Hsws"};